import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
// import Home from '../views/Home.vue'


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location: any) {
  return (originalPush.call(this, location) as any).catch((err: any) => err)
}

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: "/time",
    component: () => import(/* webpackChunkName: "time" */ "../views/Time.vue"),
  },
  {
    path: '/',
    name: 'container',
    component: () => import(/* webpackChunkName: "container" */ '../components/Container.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
        meta: { content: "首页" }
      },
      {
        path: "/knowledgeSystem",
        name: 'knowledgeSystem',
        component: () => import(/* webpackChunkName: "knowledgeSystem" */ '../views/KnowledgeSystem.vue'),
        meta: { content: "知识体系" }
      },
      {
        path: "/talentDev",
        name: 'TalentDev',
        component: () => import(/* webpackChunkName: "TalentDev" */ '../views/TalentDev.vue'),
        meta: { content: "人才发展" }
      },
      {
        path: "/studyandExam",
        name: 'StudyandExam',
        component: () => import(/* webpackChunkName: "StudyandExam" */ '../views/StudyandExam.vue'),
        meta: { content: "学习与考试" }
      },
      {
        path: "/signUp",
        name: 'signUp',
        component: () => import(/* webpackChunkName: "signUp" */ '../views/SignUp.vue'),
        meta: { content: "报名缴费" }
      },
      {
        path: "/ipph",
        name: 'ipph',
        component: () => import(/* webpackChunkName: "signUp" */ '../views/Ipph.vue'),
        meta: { content: "知识产权出版社" }
      },
      {
        path: "/expertlist",
        name: 'expertlist',
        component: () => import(/* webpackChunkName: "signUp" */ '../views/ExpertList.vue'),
        meta: { content: "专家列表" }
      },
      {
        path: "/companylist",
        name: 'companylist',
        component: () => import(/* webpackChunkName: "signUp" */ '../views/CompanyList.vue'),
        meta: { content: "展商发布" }
      },
      // {
      //   path: '/projectList',
      //   name: 'projectList',
      //   component: () => import('../views/ProjectList.vue'),
      //   meta: { content: "百佳案例榜单" }
      // },
      // {
      //   path: 'projectList/detail/:pid',
      //   name: 'project',
      //   component: () => import('../views/Project.vue'),
      //   meta: { content: "详情", faterRoute: "projectList" }
      // },
      // {
      //   path: '/projectList_intro',
      //   name: 'projectList_intro',
      //   component: () => import('../views/ProjectList_intro.vue'),
      //   meta: { content: "案例介绍" }
      // },
      // {
      //   path: 'projectList/case/:pid',
      //   name: 'case',
      //   component: () => import('../views/Project.vue'),
      //   meta: { content: "详情", faterRoute: "projectList_intro" }
      // },
      {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      }
    ]
  },


]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
